import * as PaymentService from "../services/PaymentService";
import {LOCALSTORAGE_ITEMS} from "../util/Constants";
import * as StorageService from "../services/StorageService";
import {confirmPayment} from "../services/ProductService";


export const createProductsOrderStripePaymentLinkHandler = async (data) => {
    let error = null;
// success payment card 4242424242424242
// failed payment card 4000000000009995
// requires auth card 4000002500003155
    const body = {
        "shop": data.shop,
        "user": data.user,
        "oid": data.oid,
        "successUrl": data.successUrl,
        "cancelUrl": data.cancelUrl

    }
    const response = await PaymentService.createProductsOrderStripePaymentLink(body);
    let paymentLink = null;

    if (response.ok) {
        paymentLink = response?.data?.link
    } else {
        error = response.data.error;
    }

    return {
        data: {
            error: error,
            paymentLink: paymentLink
        }
    };
}


export const createProductsOrderPaymentLinkHandler = async (data) => {
    let error = null;

    const body = {
        "shop": data.shop,
        "user": data.user,
        "oid": data.oid,
    }
    const response = await PaymentService.createProductsOrderPaymentLink(body);
    let paymentLink = null;

    if (response.ok) {
        paymentLink = response.data
    } else {
        error = response.data.error;
    }

    return {
        data: {
            error: error,
            id: paymentLink
        }
    };
}

export const savePaymentCardHandler = async (data) => {

    const body = {
        "shop": data.shop,
        "user": data.user,
        "transactionId": data.transactionId,
    }
    const response = await PaymentService.savePaymentCard(body);

    if (response.ok) {
        return response.data;
    } else {
        return response.data.error;
    }
}

export const payProductsOrderHandler = async (data) => {

    const body = {
        "shop": data.shop,
        "user": data.user,
        "oid": data.oid,
        "transactionId":data.transactionId
    }
    const response = await PaymentService.payProductsOrder(body);
    return response.data;
}

export const initializePayLikeScript = async (config) => {
    return new Promise((resolve, reject) => {
        const existingScript = document.querySelector('script[src="https://sdk.paylike.io/10.js"]');
        if (existingScript) {
            openPayLikePayment(config, resolve, reject);

        } else {
            const script = document.createElement('script');
            script.src = 'https://sdk.paylike.io/10.js';
            script.async = true;
            script.onload = () => {
                openPayLikePayment(config, resolve, reject);
            };
            document.body.appendChild(script);
        }
    });
};

const openPayLikePayment = (config, resolve, reject) => {
    const bodyForPaymentLink = {
        "shop": StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME),
        "user": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
        "oid": StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_ID),
    }
    createProductsOrderPaymentLinkHandler(bodyForPaymentLink).then(response=>{
        if (!response.data.error) {


            const paylikeParams = new URLSearchParams(response.data.id.link.substring(response.data.id.link.indexOf("?")+1));
            const publicKey = paylikeParams.get("key");
            const isTestAccount = paylikeParams.get("test") === "1";
            const paylike = window.Paylike({ key: publicKey});
            paylike.pay({...config, test: isTestAccount}, (error, result) => {
                if (error) {
                    console.log("Paylike Error from Handler:", error);
                    reject(error);
                } else {
                    resolve(result.transaction.id);
                }
            });
        }else{
            console.log("createProductsOrderPaymentLinkHandler ERROR", response.data);
            reject(response.data.error);
        }

    })
};

export const confirmPaymentHandler = async (shopName, orderId, transactionId) => {
    const confirmationResponse = await confirmPayment(shopName, orderId, transactionId);
    if (confirmationResponse.ok) {
       return confirmationResponse;
    } else {
        return "Error confirmPaymentHandler";
    }
}


